import React, { Component } from 'react';

import Item, { types } from './Item';

import './styles.css';

class DashboardCompletedOverviewComparative extends Component {
  render() {
    const {
      earlyPc,
      onTimePc,
      LatePc,
      className,
      performanceOnTime,
      performanceLate,
      performanceEarly,
    } = this.props;

    return (
      <div
        className={`DashboardCompletedOverviewComparative ${className || ''}`}
      >
        <div className="DashboardCompletedOverviewComparative__title">
          Situação das NFs
        </div>
        <div className="DashboardCompletedOverviewComparative__list">
          <Item
            className="DashboardCompletedOverviewComparative__item"
            value={onTimePc}
            type={types.ON_TIME}
            label="No prazo"
            quantity={performanceOnTime}
          />
          <Item
            className="DashboardCompletedOverviewComparative__item"
            value={earlyPc}
            type={types.EARLY}
            label="Antecipado"
            quantity={performanceEarly}
          />
          <Item
            className="DashboardCompletedOverviewComparative__item"
            value={LatePc}
            type={types.LATE}
            label="Atrasado"
            quantity={performanceLate}
          />
        </div>
      </div>
    );
  }
}

export default DashboardCompletedOverviewComparative;
